import { useCheckpointRedirect } from "./hooks/useCheckpointRedirect";
import { useTriggerCheckpoint } from "./hooks/useTriggerCheckpoint";
import { CheckpointProps } from "./types";

/**
 * Triggers the checkpoint when rendered
 * Redirect to checkpoint if conditions have been met
 */
const Checkpoint = ({ checkpoint, path, children }: CheckpointProps) => {
  useTriggerCheckpoint({ checkpoint, path });

  useCheckpointRedirect(path);

  return children;
};

export default Checkpoint;
